import React, { useState, useEffect } from 'react';
import { Formik } from 'formik';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import FormWrapper from '~FormWrapper';
import InstrumentsForm from './InstrumentsForm';

import { Spinner } from '~ui-kit';

import { useOnSubmit } from '~hooks/useOnSubmit';
import { useOnEdit } from '~hooks/useOnEdit';
import { getUserOrdererOrganizationId } from '~features/user/ducks';
import {
  getTimeInfo,
  fetchTransferOrganizations,
} from '../../services/api.helpers';
import { removeEmptyKeys } from '../validations';

const validate = values => {
  const errors = {};

  if (!values.organization) {
    errors.organization = 'Vaadittu';
  }

  if (!values.pickupAddress) {
    errors.pickupAddress = 'Vaadittu';
  }

  return removeEmptyKeys(errors);
};

const getInitialValues = (orgs, userOrgId) => {
  const userOrganization = orgs?.find(org => org.id === userOrgId);

  const initialValues = {
    organization: userOrganization
      ? { value: userOrganization.id, label: userOrganization.name }
      : null,
    pickupAddress: null,
  };

  return initialValues;
};

const Instruments = props => {
  const { formId, edit } = props;
  const [timeInfo, setTimeInfo] = useState();
  const [organizations, setOrganizations] = useState();
  const [initialValues, setInitialValues] = useState();
  const { orderId } = useParams();
  const userOrganizationId = useSelector(state =>
    getUserOrdererOrganizationId(state)
  );

  useEffect(() => {
    const update = async () => {
      try {
        const [orgs, tempTimeInfo] = await Promise.all([
          fetchTransferOrganizations(formId),
          getTimeInfo(formId),
        ]);
        setOrganizations(orgs);
        setTimeInfo(tempTimeInfo);
        setInitialValues(getInitialValues(orgs, userOrganizationId));
      } catch (e) {
        console.error('Error when fetching organizations and time info:', e);
        setInitialValues(getInitialValues(null, null));
      }
    };

    update();
  }, []);

  const onFormSubmit = useOnSubmit();
  const onFormEdit = useOnEdit();

  if (!initialValues) return <Spinner />;

  return (
    <Formik
      initialValues={initialValues}
      validate={validate}
      onSubmit={async (values, { setSubmitting }) => {
        setSubmitting(true);
        const method = edit ? onFormEdit : onFormSubmit;
        await method({
          fields: {
            ...values,
            organization: values.organization?.value,
          },
          setSubmitting,
          orderId,
          formId,
        });
      }}
    >
      {formikProps => (
        <FormWrapper
          {...props}
          title="Välinehuolto"
          organizations={organizations}
          timeInfo={timeInfo}
          formik={formikProps}
          Component={InstrumentsForm}
        />
      )}
    </Formik>
  );
};

export default Instruments;
